const MagnifyingGlasWhite = () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle opacity="0.8" cx="24" cy="24" r="24" fill="white" />
        <path fillRule="evenodd" clipRule="evenodd" d="M30 23C30 26.866 26.866 30 23 30C19.134 30 16 26.866 16 23C16 19.134 19.134 16 23 16C26.866 16 30 19.134 30 23ZM28.6177 30.0319C27.078 31.2635 25.125 32 23 32C18.0294 32 14 27.9706 14 23C14 18.0294 18.0294 14 23 14C27.9706 14 32 18.0294 32 23C32 25.125 31.2635 27.078 30.0319 28.6177L34.9144 33.5002L33.5002 34.9144L28.6177 30.0319Z" fill="black" />
    </svg>
)

export default MagnifyingGlasWhite;